import { useEffect, useState } from "react";
import { UseFormReturn } from "react-hook-form";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import { AutoCompleteOption } from "../common/AutoComplete";
import FormInput from "../common/FormInput";
import GenericFilterBox from "../common/GenericFilterBox";
import { nameof } from "../common/ObjectUtils";
import ETollImportService from "./service/ETollImportService";
import { ETollTypes } from "./tasks/Types";

interface Props {
    form: UseFormReturn<ETollTypes.IFormInput, any>;
}

const ETollImportFilterAndSearch = (props: Props) => {
    const [statusList, setStatusList] = useState<AutoCompleteOption[]>([]);

    const t = useOperationTranslation();

    const changeStatusName = (statusName: string) => {
        switch (statusName) {
            case "PROCESSED":
                return t("eTollImport.statusType.processed");
            case "PENDING":
                return t("eTollImport.statusType.pending");
            case "WITH_ERRORS_FORMAT":
                return t("eTollImport.statusType.errorFormat");
            case "WITH_ERRORS_DATA_INTEGRITY":
                return t("eTollImport.statusType.dataIntegrityError");
            case "WITH_ERRORS_GENERIC_ERROR":
                return t("eTollImport.statusType.genericError");
            default:
                return "";
        }
    };

    useEffect(() => {
        ETollImportService.get.rfidStatus().then(
            response => {
                console.log(response);
                setStatusList(response.map(status => ({
                    label: changeStatusName(status),
                    value: status
                })))
            }
        )
    }, []);

    const onReset = () => {
        props.form.reset({
            fileName: "",
            startDatetimeFrom: null,
            startDatetimeTo: null,
            status: ""
        })
    }

    return(
        <>
            <form id="idRfidForm" onSubmit={props.form.handleSubmit(() => {})}>
                <GenericFilterBox
                    formId="idRfidForm"
                    onReset={onReset}
                    showExtrasFilters={true}
                >
                    <FormInput
                        type="text"
                        fullWidth
                        label={t("eTollImport.fileName")}
                        variant="standard"
                        id="fileName"
                        name={nameof<ETollTypes.IFormInput>("fileName")}
                        formInstance={props.form}
                        inputProps={{
                            pattern: "[^%*$\"+&?^~Â`£=!@'/§#]{0,}",
                            onInput: (event) => {
                                if (event.currentTarget.validity.patternMismatch) {
                                event.currentTarget.setCustomValidity(
                                    t("eTollImport.regexMessage")
                                );
                                } else {
                                event.currentTarget.setCustomValidity("");
                                }
                            },
                        }}
                    />

                    <FormInput
                        type="date"
                        label={t("eTollImport.startDate")}
                        fullWidth
                        name={nameof<ETollTypes.IFormInput>("startDatetimeFrom")}
                        formInstance={props.form}
                        inputFormat={"DD/MM/YYYY HH:mm"}
                        ampm={false}
                        value={props.form.watch("startDatetimeFrom")}
                    />

                    <FormInput
                        type="date"
                        label={t("eTollImport.endDate")}
                        fullWidth
                        name={nameof<ETollTypes.IFormInput>("startDatetimeTo")}
                        formInstance={props.form}
                        inputFormat={"DD/MM/YYYY HH:mm"}
                        ampm={false}
                        value={props.form.watch("startDatetimeTo")}
                    />

                    <FormInput
                        type="select"
                        options={statusList}
                        name={nameof<ETollTypes.IFormInput>("status")}
                        formInstance={props.form}
                        fullWidth
                        label={t("eTollImport.status")}
                    />
                </GenericFilterBox>
            </form>
        </>
    )
}
export default ETollImportFilterAndSearch;
